import * as React from 'react';

import { Box, Button, Link, Text } from '@opendoor/bricks-next';

import { addressEntryUrl } from 'src/helpers/globals';
import { SellerInputAddress } from 'src/store/sellerInput';

import { IAddress } from '../../declarations';

const AddressLine: React.FC<{ address: IAddress | SellerInputAddress }> = ({ address }) => {
  return (
    <Box>
      <Text
        typography="$labelMedium"
        $largerThanSM={{ fontSize: '$labelLarge' }}
        tag="label"
        mb={8}
      >
        Looking for another home?
      </Text>
      <Box justifyContent="space-between" display="flex" flexDirection="row">
        <Text typography="$bodyMedium" $largerThanMD={{ display: 'inline' }} tag="p">
          {address.street}
          <Text
            tag="span"
            typography="$bodyMedium"
            display="none"
            $largerThanMD={{ display: 'inline' }}
          >
            ,&nbsp;
          </Text>
          <Text
            tag="span"
            typography="$bodyMedium"
            display="block"
            $largerThanMD={{ display: 'inline' }}
          >
            {address.city}, {address.state} {address.postalCode}
          </Text>
        </Text>
        <Box tag="span" display="none" $largerThanMD={{ display: 'inline' }}>
          <Link
            typography="$labelLarge"
            href={addressEntryUrl}
            ml={5}
            analyticsName="reception-fe-change-address"
            aria-label={'Click to change address'}
          >
            Edit
          </Link>
        </Box>
      </Box>
      <Box mt={16} display="block" $largerThanMD={{ display: 'none' }}>
        <Button
          href={addressEntryUrl}
          analyticsName="reception-fe-change-address"
          variant="secondary"
          label="Edit"
          size="small"
          width="100%"
        />
      </Box>
    </Box>
  );
};

export default AddressLine;
